<template>
  <header class="Header" :class="platform">
    <div class="inner">
      <div class="left-section">
        <NuxtLink :to="home">
          <div class="home-nav">
            <div class="header-logo">
              <picture>
                <source type="image/webp" srcset="https://assets.ka-nabell.com/common/logo.webp" width="98" height="24">
                <img src="https://assets.ka-nabell.com/common/logo.png" alt="カーナベル" width="98" height="24" />
              </picture>
            </div>
            <div v-if="platform !== 'common'" class="header-nav">
              <p>{{ platformStr }}</p>
              <span class="separator"></span>
              <p>ポケカ</p>
            </div>
          </div>
        </NuxtLink>
      </div>
      <div class="content">
        <slot />
      </div>
    </div>
  </header>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";

export default defineComponent({
  props: {
    platform: {
      type: String as () => "common" | "sell" | "buy" | "profile",
      default: "common",
    },
    home: {
      type: String,
      default: "/",
    },
  },
  setup(props) {
    const platformStr = computed(() => {
      switch (props.platform) {
        case "common":
          return ''
        case "sell":
          return "販売"
        case "buy":
          return "買取"
        case "profile":
          // TODO: シングル買取リリース時「共通」に
          return "販売"
        default:
          return ""
      }
    })

    return {
      platformStr,
    };
  },
});
</script>

<style scoped>
.Header {
  width: 100%;
  height: 56px;
  background: var(--primitive-colors-neutral-white-400);
  box-sizing: border-box;
  margin: 0 auto;
}

@media screen and (min-width: 430px) {
  .Header {
    width: 430px;
  }
}

.Header.common {
  border-bottom: 2px solid var(--semantic-colors-border-black);
}

.Header.sell {
  border-bottom: 4px solid;
  border-image: var(--primitive-colors-gradient-pink-yellow-500);
  border-image-slice: 1;
}

.Header.buy {
  border-bottom: 4px solid;
  border-image: var(--primitive-colors-gradient-blue-yellow-500);
  border-image-slice: 1;
}

.Header.profile {
  border-bottom: 4px solid;
  border-image: var(--primitive-colors-gradient-colorful-500);
  border-image-slice: 1;
}

.inner {
  width: 100%;
  height: 100%;
  padding: 0px 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: auto;
}

.left-section {
  height: 100%;
  display: flex;
  gap: 8px;
  align-items: center;
}

.left-section a {
  text-decoration: none;
}

.header-logo {
  width: 98px;
  height: 23.5px;
}

.header-logo img {
  max-height: 100%;
}

.header-nav {
  display: flex;
  gap: 4px;
  align-items: center;
}

.header-nav p {
  color: var(--semantic-colors-text-black);
  font-size: var(--font-size-small);
  font-style: normal;
  font-weight: 700;
  line-height: 160%;
  letter-spacing: 0.1px;
}

.separator {
  display: inline-block;
  width: 1px;
  height: 14px;
  background: var(--primitive-colors-neutral-white-800);
}

.content {
  height: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
}

.home-nav {
  display: flex;
  gap: 8px;
  align-items: center;
}
</style>
